import { useEffect, useState } from 'react';
import useUser from 'utils/useUser';
import { useReservePatient } from 'infrastructure/hooks/rpm';

import AssignSwitch from './components/assign-switch';
import ErroneousWrapper from './components/erroneous-modal';
import s from './styles.module.scss';

import type { TView } from './types';
import type { QueryKey } from '@tanstack/react-query';
import type { FC } from 'react';
import type { IActivityData } from 'infrastructure/interfaces/i-rpm-patient-activity';

interface MobileActionsRowProps {
  record: IActivityData;
  view: TView;
  getActivityQueryKey: QueryKey;
}

const MobileActionsRow: FC<MobileActionsRowProps> = ({
  record,
  view,
  getActivityQueryKey,
}) => {
  const [checked, setChecked] = useState(!!record.reserved);
  const { loginGuid, isAgencyDoctor, isCriticalOrAtRiskAlertingRole } =
    useUser();
  const { reservePatient, isLoading } = useReservePatient({
    getActivityQueryKey,
  });

  useEffect(() => {
    setChecked(!!record.reserved);
  }, [!!record.reserved]);

  return (
    <div className={s['mob-action-wrapper']}>
      {isAgencyDoctor && !isCriticalOrAtRiskAlertingRole && (
        <AssignSwitch
          checked={checked}
          isLoading={isLoading}
          loginGuid={loginGuid}
          reserved={record.reserved}
          onChange={() => {
            setChecked((prev) => !prev);
            reservePatient(record.patient.guid);
          }}
        />
      )}
      {view !== 'dashboard' && !record.isErroneous && (
        <ErroneousWrapper
          deviceId={record.deviceId}
          readingId={record.id}
          isErroneous={record.isErroneous}
          getActivityQueryKey={getActivityQueryKey}
        />
      )}
    </div>
  );
};
export default MobileActionsRow;
